import { AuditName } from "../enums";

export const getServerUrlPrefix = auditName => {
    let serverUrl;
    switch (auditName) {
        case AuditName.ACCOUNT:
            serverUrl = '/accounts';
            break;
        case AuditName.CONTACT:
            serverUrl = '/contacts';
            break;
        case AuditName.PRODUCT:
            serverUrl = '/products';
            break;
        default:
            throw new Error('Invalid auditName');
    }
    return serverUrl;
};
